import React from 'react';
import {
  Typography,
} from '@mui/material';
import { GTNumberRangePayload } from '../../redux/types';

type Props = {
  payload: GTNumberRangePayload;
};

const GTNumberRangeScore: React.FC<Props> = ({
  payload,
}: Props) => (
  <>
    <div>
      <Typography
        variant="body2"
        component="span"
        fontWeight={600}
      >
        {payload.correct.score}
      </Typography>
      {' '}
      <Typography variant="body2" component="span">
        {
            payload.correct.range.length
              ? `[${payload.correct.range.join('], [')}]`
              : ''
          }
      </Typography>
    </div>
    <div>
      <Typography
        variant="body2"
        component="span"
        color="textSecondary"
        fontWeight={600}
      >
        {payload.acceptable.score}
      </Typography>
      {' '}
      <Typography variant="body2" color="textSecondary" component="span">
        {
            payload.acceptable.range.length
              ? `[${payload.acceptable.range.join('], [')}]`
              : ''
          }
      </Typography>
    </div>
  </>
);

export default GTNumberRangeScore;
